import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Injectable } from '@angular/core'; 
import { of } from 'rxjs';
import * as actions from './actions';
import { LocationService } from '../../services/location.service';
import { AlertService } from '../../services/alert.service';
import { switchMap, catchError, map } from 'rxjs/operators';
import { LocationDto } from 'src/app/services/bpp.webapi/client';

@Injectable()
export class LocationEffects {
  constructor(
    protected store: Store<AppState>,
    protected service: LocationService,
    protected action$: Actions,
    private alertService: AlertService
  ) { }

  GetLocations$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetLocationsAction>(actions.GET_LOCATIONS),
    switchMap(action => this.service.getLocations(action.clubId).pipe(
      map((result) => new actions.GetLocationsSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.LocationApiErrorAction(error));
      })))));

  CreateLocationEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.CreateLocationAction>(actions.CREATE_LOCATION),
    switchMap(action => this.service.createLocation(action.payload).pipe(
      map((result) => new actions.CreateLocationSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.CreateLocationErrorAction(error));
      })))));

  UpdateLocationEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.UpdateLocationAction>(actions.UPDATE_LOCATION),
    switchMap(action => this.service.updateLocation(action.payload).pipe(
      map((result) => new actions.UpdateLocationSuccessAction(result)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.UpdateLocationErrorAction(error));
      })))));

  DeleteLocationEvent$ = createEffect(() => this.action$.pipe(
    ofType<actions.DeleteLocationAction>(actions.DELETE_LOCATION),
    switchMap(action => this.service.deleteLocation(action.locationId).pipe(
      map((result) => new actions.DeleteLocationSuccessAction(action)),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.DeleteLocationErrorAction(error));
      })))));

  GetInterviewLocations$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetInterviewLocationsAction>(actions.GET_INTERVIEW_LOCATIONS),
     switchMap(action => this.service.getForLeague().pipe(
      switchMap((res: LocationDto[]) => of(new actions.GetInterviewLocationsActionSuccess(res))),
      catchError(error => {
        this.alertService.error(error);
        return of(new actions.LocationApiErrorAction(error));
      })))));
}
